<template>
    <g>
        <circle cx="8" cy="8" r="8" fill="#206CFF" />
        <circle cx="8" cy="8" r="3" fill="white" />
    </g>
</template>
<script>
export default {
    name: "RadioCheckedBlue",
};
</script>
